import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { APP_ROUTES } from './hooks/useAppNavigation';

class ErrorBoundaryHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Possible to log the error to a service
    this.props.onError?.(error, errorInfo);
  }

  componentDidUpdate(prevProps, prevState) {
    // Reset error when location changes (handled via key prop from parent)
    if (prevProps.location !== this.props.location && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}


const ErrorBoundary = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleError = (error, info) => {
    console.error("Logged error:", error);
    navigate(APP_ROUTES.ERROR);
  };

  return (
    <ErrorBoundaryHandler
      onError={handleError}
      location={location}
      fallback={null}
    >
      {children}
    </ErrorBoundaryHandler>
  );
};

export default ErrorBoundary;